export default "__VITE_ASSET__52Yg_hS2__"